// token

// const domain = 'http://127.0.0.1:8088'
// const domain = 'https://apitest.newaircloud.com'
const domain = ''

// eslint-disable-next-line no-unused-vars
const _TOKEN = domain + '/api/getAppToken'

// 话题详情
const _GETTOPICINFO = domain + '/topicApi/getTopicInfoDy'

// 互动接口
const _SUBEVENT = domain + '/api/subEventDy'

// 参与话题点赞
const _DISCUSSPRAISE = domain + '/topicApi/discussPraiseDy'

// app配置信息
const _GETCONFIG = domain + '/api/getConfigDy'

// 参与话题详情内容
const _GETTOPICDISCUSSCONTENT = domain + '/topicApi/getTopicDiscussContentDy'

// 参与详情热门评论
const _GETHOTCOMMENTS = domain + '/api/getHotCommentsDy'

// 参与详情评论
const _GETCOMMENTS = domain + '/api/getCommentsDy'

// 话题详情参与列表
const _GETDISCUSSLIST = domain + '/topicApi/getDiscussListDy'

// 话题参与详情评论提交
const _SUBMITCOMMENT = domain + '/api/submitCommentDy'

// 话题详情
const _GETTOPICADV = domain + '/topicApi/getTopicAdv'

export default ({
  _TOKEN,
  _GETTOPICINFO,
  _SUBEVENT,
  _DISCUSSPRAISE,
  _GETCONFIG,
  _GETTOPICDISCUSSCONTENT,
  _GETHOTCOMMENTS,
  _GETCOMMENTS,
  _GETDISCUSSLIST,
  _SUBMITCOMMENT,
  _GETTOPICADV
})



// WEBPACK FOOTER //
// ./src/tool/url.js